import { c as _c } from "react/compiler-runtime";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useRef, useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { getQueryParams } from "@/lib/utils/get-query-params";
import qs from "qs";
import { useProjectMediaGalleriesState } from "@/store/store";
const headers = {
  "x-internal-client": "DIGITAL_PROFILE",
  "x-channel": "CONTRACTOR_WEB"
};
const galleryOptions = {
  method: "GET",
  headers: headers,
  next: {
    revalidate: 180,
    // 3 minutes for gallery data (updates more frequently)
    tags: ["project-gallery"]
  }
};
const fetchProjectMediaGalleries = async query => {
  const queryString = qs.stringify(query);
  const response = await fetch(`/v1/api/cms/project-media-galleries?populate=*&${queryString}`, galleryOptions);
  const projects = await response.json();
  return projects;
};
const DEFAULT_SORT = "image_score";
export const useInfiniteImage = (digitalProfile, selectedTag) => {
  const $ = _c(36);
  const loadMoreRef = useRef(null);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("sortBy") ?? DEFAULT_SORT;
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const sortBy = t0;
  const {
    projectMediaGalleries,
    setProjectMediaGalleries
  } = useProjectMediaGalleriesState();
  const t1 = digitalProfile?.id;
  let t2;
  if ($[2] !== selectedTag || $[3] !== sortBy || $[4] !== t1) {
    t2 = ["gallery-images", t1, selectedTag, sortBy];
    $[2] = selectedTag;
    $[3] = sortBy;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== digitalProfile?.id || $[7] !== selectedTag || $[8] !== sortBy) {
    t3 = t4 => {
      const {
        pageParam: t5
      } = t4;
      const pageParam = t5 === undefined ? 1 : t5;
      const queryParams = getQueryParams({
        pageNumber: pageParam,
        digitalProfileId: digitalProfile?.id,
        selectedTag: selectedTag ?? "All",
        sortBy
      });
      return fetchProjectMediaGalleries(queryParams);
    };
    $[6] = digitalProfile?.id;
    $[7] = selectedTag;
    $[8] = sortBy;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = !!digitalProfile?.id;
  let t5;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      getNextPageParam: _temp,
      enabled: t4
    };
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const {
    data,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage
  } = useInfiniteQuery(t5);
  let t6;
  let t7;
  if ($[14] !== fetchNextPage || $[15] !== hasNextPage || $[16] !== isFetchingNextPage) {
    t6 = () => {
      const currentObserver = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && hasNextPage && !isFetchingNextPage) {
          fetchNextPage();
        }
      }, {
        threshold: 1
      });
      const currentRef = loadMoreRef.current;
      if (currentRef) {
        currentObserver.observe(currentRef);
      }
      return () => {
        if (currentRef) {
          currentObserver.unobserve(currentRef);
        }
      };
    };
    t7 = [hasNextPage, isFetchingNextPage, fetchNextPage];
    $[14] = fetchNextPage;
    $[15] = hasNextPage;
    $[16] = isFetchingNextPage;
    $[17] = t6;
    $[18] = t7;
  } else {
    t6 = $[17];
    t7 = $[18];
  }
  useEffect(t6, t7);
  let t8;
  if ($[19] !== selectedTag || $[20] !== sortBy) {
    t8 = [selectedTag, sortBy];
    $[19] = selectedTag;
    $[20] = sortBy;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  useEffect(_temp2, t8);
  let t10;
  let t9;
  if ($[22] !== data || $[23] !== projectMediaGalleries.tag_id_filters || $[24] !== setProjectMediaGalleries) {
    t9 = () => {
      if (data?.pages) {
        const allData = data.pages.flatMap(_temp3);
        const meta = data.pages[0]?.meta || {};
        setProjectMediaGalleries({
          data: allData,
          meta,
          tag_id_filters: projectMediaGalleries.tag_id_filters || []
        });
      }
    };
    t10 = [data, setProjectMediaGalleries, projectMediaGalleries.tag_id_filters];
    $[22] = data;
    $[23] = projectMediaGalleries.tag_id_filters;
    $[24] = setProjectMediaGalleries;
    $[25] = t10;
    $[26] = t9;
  } else {
    t10 = $[25];
    t9 = $[26];
  }
  useEffect(t9, t10);
  let t11;
  if ($[27] !== projectMediaGalleries.data) {
    t11 = projectMediaGalleries.data || [];
    $[27] = projectMediaGalleries.data;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  const projectMediaGalleriesData = t11;
  const totalElements = projectMediaGalleries.meta?.pagination?.total || 0;
  let t12;
  if ($[29] !== fetchNextPage || $[30] !== hasNextPage || $[31] !== isFetchingNextPage || $[32] !== isLoading || $[33] !== projectMediaGalleriesData || $[34] !== totalElements) {
    t12 = {
      projectMediaGalleries: projectMediaGalleriesData,
      isLoading,
      isFetchingNextPage,
      hasNextPage,
      loadMoreRef,
      totalElements,
      fetchNextPage
    };
    $[29] = fetchNextPage;
    $[30] = hasNextPage;
    $[31] = isFetchingNextPage;
    $[32] = isLoading;
    $[33] = projectMediaGalleriesData;
    $[34] = totalElements;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
};
function _temp(lastPage, allPages) {
  const totalPages = Math.ceil(lastPage?.meta?.pagination?.total / 10);
  const currentPage = allPages.length;
  return currentPage < totalPages ? currentPage + 1 : undefined;
}
function _temp2() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}
function _temp3(page) {
  return page?.data || [];
}